
import '../../extensions/string.extensions';

import { AfterViewInit, Component, Input } from '@angular/core';
import { ObservableInput } from 'ngx-observable-input';
import { empty, fromEvent, merge, Observable, of, Subject } from 'rxjs';
import { filter, map, startWith, switchMap, first } from 'rxjs/operators';

import 'core-js/actual/array/group';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatDialog } from '@angular/material/dialog';
import { CradleToGravePopUpComponent } from '../cradle-to-grave-pop-up/cradle-to-grave-pop-up.component';
import { GraphQLComparision } from '../../enums/GraphQLComparision.enum';
import { GraphQLFilter, IGraphQlService } from '../../services/GraphQl/IGraphQL.service';

@Component({
  selector: 'cradle-to-grave',
  templateUrl: './cradle-to-grave.component.html',
  styleUrls: ['./cradle-to-grave.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class CradleToGraveComponent implements AfterViewInit {



  @ObservableInput()
  @Input("initialCallId")
  initialCallId$: Observable<string>;


  telepoCdrs: Observable<Array<TelepoCdr>>;

  callLegs: Observable<any[]>;

  expandedCallIds: Set<String> = new Set([]);


  constructor(public graphQlService: IGraphQlService, public dialog: MatDialog) {

  }


  ngAfterViewInit(): void {
    this.telepoCdrs = fromEvent(document, "visibilitychange").pipe(
      startWith(null),
      switchMap(() => {
        if (document.visibilityState === "hidden") return empty();
        const refreshSubject = new Subject<number>();
        return merge(of(0), refreshSubject).pipe(map(() => refreshSubject));
      }),
      switchMap(refreshSubject => this.initialCallId$.pipe(
        filter(i => i != null),
        switchMap(initialCallId => this.graphQlService.getGraphQlResults({
          dataset: "telepoCdrsPage",
          selects: [
            { field: "version", arguments: null },
            { field: "orgId", arguments: null },
            { field: "customerId", arguments: null },
            { field: "startTime", arguments: null },
            { field: "deviceIp", arguments: null },
            { field: "billingUserId", arguments: null },
            { field: "billingId", arguments: null },
            { field: "completed", arguments: null },
            { field: "duration", arguments: null },
            { field: "type", arguments: null },
            { field: "callPartiesRelation", arguments: null },
            { field: "dialString", arguments: null },
            { field: "callId", arguments: null },
            { field: "previousCallId", arguments: null },
            { field: "initialCallId", arguments: null },
            { field: "billingPhoneNumber", arguments: null },
            { field: "billingCostCentre", arguments: null },
            { field: "billingDepartment", arguments: null },
            { field: "billingRole", arguments: null },
            { field: "waitBeforeAnswer", arguments: null },
            { field: "result", arguments: null },
            { field: "sourceUserId", arguments: null },
            { field: "sourcePhoneNumber", arguments: null },
            { field: "sourceCostCentre", arguments: null },
            { field: "sourceDepartment", arguments: null },
            { field: "sourceRole", arguments: null },
            { field: "sourceApType", arguments: null },
            { field: "sourceOwnerTypeId", arguments: null },
            { field: "sourceOwnerId", arguments: null },
            { field: "sourceOwner", arguments: null },
            { field: "targetUserId", arguments: null },
            { field: "targetPhoneNumber", arguments: null },
            { field: "targetCostCentre", arguments: null },
            { field: "targetDepartment", arguments: null },
            { field: "targetRole", arguments: null },
            { field: "targetApType", arguments: null },
            { field: "targetOwnerTypeId", arguments: null },
            { field: "targetOwnerId", arguments: null },
            { field: "targetOwner", arguments: null },
            { field: "transferredBy", arguments: null },
            { field: "divertedBy", arguments: null },
            { field: "diversionReason", arguments: null },
            { field: "trunk", arguments: null },
            { field: "trunkGroup", arguments: null },
            { field: "trunkCallId", arguments: null },
            { field: "breakOutNumber", arguments: null },
            { field: "trunkDestinationNumber", arguments: null },
            { field: "trunkDestinationNumberingPlan", arguments: null },
            { field: "trunkDestinationNumberingType", arguments: null },
            { field: "trunkDestinationTags", arguments: null },
            { field: "trunkSourceNumber", arguments: null },
            { field: "trunkSourceNumberingPlan", arguments: null },
            { field: "trunkSourceNumberingType", arguments: null },
            { field: "sourcePrivacy", arguments: null },
            { field: "trunkSourceTags", arguments: null },
            { field: "trunkRedirectingNumber", arguments: null },
            { field: "trunkRedirectingNumberingPlan", arguments: null },
            { field: "trunkRedirectingNumberingType", arguments: null },
            { field: "trunkGroupChargingNumber", arguments: null },
            { field: "q850CauseCode", arguments: null },
            { field: "cancelCauseCode", arguments: null },
            { field: "conferenceId", arguments: null },
            { field: "targetPrivacy", arguments: null },
            { field: "elapsedSinceLastEvent", arguments: null },
            { field: "eventSequenceNumber", arguments: null },
            { field: "eventTimestamp", arguments: null },
            { field: "sourceOrgId", arguments: null },
            { field: "targetOrgId", arguments: null },
            { field: "transferredByOrgId", arguments: null },
            { field: "divertedByOrgId", arguments: null },
            { field: "sourceAllocationId", arguments: null },
            { field: "targetAllocationId", arguments: null },
            { field: "messageTypeWeight", arguments: null },
            { field: "sourcePhoneNumberAreaCode", arguments: null },
            { field: "targetPhoneNumberAreaCode", arguments: null },
            { field: "sourceMOS", arguments: null },
            { field: "sourceRFactor", arguments: null },
            { field: "sourceAvgLatency", arguments: null },
            { field: "sourceMaxLatency", arguments: null },
            { field: "sourcePacketsLost", arguments: null },
            { field: "sourceAvgJitter", arguments: null },
            { field: "sourceMaxJitter", arguments: null },
            { field: "targetMOS", arguments: null },
            { field: "targetRFactor", arguments: null },
            { field: "targetAvgLatency", arguments: null },
            { field: "targetMaxLatency", arguments: null },
            { field: "targetPacketsLost", arguments: null },
            { field: "targetAvgJitter", arguments: null },
            { field: "targetMaxJitter", arguments: null }
          ],
          wheres: [{
            path: "initialCallId",
            comparison: GraphQLComparision.EQUAL,
            value: initialCallId
          } as GraphQLFilter],
          groupBys: null,
          page: 0,
          pageSize: 100000,
          orderBy: null
        })),
        map(result => ({ telepoCdrsPage: result.data.telepoCdrsPage.items as Array<TelepoCdr>, refreshSubject }))
      )),
      //tap(({ refreshSubject }) => setTimeout(() => refreshSubject.next(0), 5000)), //uncomment to enable auto updating
      map(({ telepoCdrsPage }) => telepoCdrsPage)
      
    );





    this.callLegs = this.telepoCdrs.pipe(
      map(TelepoCdrsToTelepoCalls)
    )
  }

  rowClick(row) {
    if (row.parentCall != null || row.divert == true) return;
    if (this.expandedCallIds.has(row.callId) == false) this.expandedCallIds.add(row.callId);
    else this.expandedCallIds.delete(row.callId);
  }

  openDialog(node): void {

    const telepoCdrs = this.telepoCdrs;
    


    telepoCdrs.pipe(first()).subscribe(telepoCdrs => this.dialog.open(CradleToGravePopUpComponent, {
      data: telepoCdrs,
    }));

  }
}



export interface TelepoCdr {
  companyOrganisationId?: number,
  companyOrganisationNode?: string,
  version?: number,
  orgId?: number,
  customerId?: string,
  startTime?: Date,
  deviceIp?: string,
  billingUserId?: string,
  billingId?: string,
  completed?: boolean
  duration?: number,
  type?: number,
  callPartiesRelation?: number,
  dialString?: string,
  callId?: string,
  previousCallId?: string,
  initialCallId?: string,
  billingPhoneNumber?: string,
  billingCostCentre?: string,
  billingDepartment?: string,
  billingRole?: string,
  waitBeforeAnswer?: number,
  result?: number,
  sourceUserId?: string,
  sourcePhoneNumber?: string,
  sourceCostCentre?: string,
  sourceDepartment?: string,
  sourceRole?: string,
  sourceApType?: number,

  targetUserId?: string,
  targetPhoneNumber?: string,
  targetCostCentre?: string,
  targetDepartment?: string,
  targetRole?: string,
  targetApType?: number,

  transferredBy?: string,
  divertedBy?: string,
  diversionReason?: number,

  trunk?: string,
  trunkGroup?: string,
  trunkCallId?: string,
  breakOutNumber?: string,
  trunkDestinationNumber?: string,
  trunkDestinationNumberingPlan?: number,
  trunkDestinationNumberingType?: number,

  trunkSourceNumber?: string,
  trunkSourceNumberingPlan?: number,
  trunkSourceNumberingType?: number,

  sourcePrivacy?: boolean,
  trunkSourceTags?: string,
  trunkRedirectingNumber?: string,

  trunkRedirectingNumberingPlan?: number,
  trunkRedirectingNumberingType?: number,
  trunkGroupChargingNumber?: string,
  q850CauseCode?: number,
  cancelCauseCode?: number,
  conferenceId?: string,
  targetPrivacy?: boolean,
  elapsedSinceLastEvent?: number,
  eventSequenceNumber?: number,
  eventTimestamp?: Date,
  sourceOrgId?: number,
  targetOrgId?: number,
  transferredByOrgId?: number,
  divertedByOrgId?: number,
  sourcePhoneNumberAreaCode?: string,
  targetPhoneNumberAreaCode?: string,

  sourceAllocationId?: number,
  sourceOwnerTypeId?: number,
  sourceOwnerId?: number,
  sourceOwner?: string,
  sourceOrganisationId?: number,
  sourceOrganisationNode?: string,


  targetAllocationId?: number,
  targetOwnerTypeId?: number,
  targetOwnerId?: number,
  targetOwner?: string,
  targetOrganisationId?: number,
  targetOrganisationNode?: string,

  sourceMOS?: number,
  sourceRFactor?: number,
  sourceAvgLatency?: number,
  sourceMaxLatency?: number,
  sourcePacketsLost?: number,
  sourceAvgJitter?: number,
  sourceMaxJitter?: number,

  targetMOS?: number,
  targetRFactor?: number,
  targetAvgLatency?: number,
  targetMaxLatency?: number,
  targetPacketsLost?: number,
  targetAvgJitter?: number,
  targetMaxJitter?: number

}




export const TelepoCdrsToTelepoCalls = (telepoCdrs: TelepoCdr[]) => {
  const telepoCalls = Array.from(telepoCdrs.groupByToMap(t => t.callId), ([callId, telepoCdrs]) => {

    const startInbound = telepoCdrs.find(telepoCdr => telepoCdr.type == 2 && telepoCdr.divertedBy == "");
    const startOutbound = telepoCdrs.find(telepoCdr => telepoCdr.type == 1 && (telepoCdr.diversionReason == null || telepoCdr.diversionReason == 1));
    const startDivert = telepoCdrs.find(telepoCdr => telepoCdr.type == 4);
    const startPickUp = telepoCdrs.find(telepoCdr => telepoCdr.type == 10);

    const telepoCall: TelepoCdr = startInbound ?? startOutbound ?? startPickUp ?? startDivert ?? (telepoCdrs.length == 1 ? telepoCdrs[0] : null);

    const divertCalls: TelepoCdr[] = [];
    (<any>telepoCall).divertCalls = divertCalls;

    const follow = (telepoCdrs: TelepoCdr[]) => {
      telepoCdrs.forEach(telepoCall => {

        if (divertCalls.indexOf(telepoCall) > -1) return;
        divertCalls.push(telepoCall);

        const divert = divertedByMap.get(telepoCall.targetUserId != "" ? telepoCall.targetUserId : telepoCall.targetPhoneNumber);
        if (divert != null) follow(divert);
      });
    };

    const divertedByMap = telepoCdrs.filter(telepoCdr => telepoCdr.divertedBy != "").groupByToMap(telepoCdr => telepoCdr.divertedBy);
    const divert = divertedByMap.get(telepoCall.targetUserId != "" ? telepoCall.targetUserId : telepoCall.targetPhoneNumber);
    if (divert != null) follow(divert);

    const missingDivert = telepoCdrs.find(telepoCdr => telepoCdr != telepoCall && telepoCdr.type == 3 && telepoCdr.targetOrgId == null)
    if (missingDivert != null) divertCalls.push(missingDivert);



    return telepoCall;
  });


  telepoCalls.forEach(currentTelepoCall => {

    const childCalls: TelepoCdr[] = telepoCalls
      .filter(telepoCall => telepoCall.previousCallId == currentTelepoCall.callId && telepoCall.sourceApType != 9)
      .sort((a, b) => new Date(a.startTime.toString()).getTime() - new Date(b.startTime.toString()).getTime() || a.type - b.type);
    (<any>currentTelepoCall).childCalls = childCalls;

  });




  const callLegs: TelepoCdr[] = [];

  var currentCallLeg = telepoCalls.find(telepoCall => telepoCall.previousCallId == "");

  while (currentCallLeg != null) {

    callLegs.push(currentCallLeg);

    (<TelepoCdr[]>(<any>currentCallLeg).divertCalls).forEach(divertCall => callLegs.push(Object.assign({ divert: true }, divertCall)));

    (<TelepoCdr[]>(<any>currentCallLeg).childCalls).forEach(childCall => callLegs.push(Object.assign({ parentCall: currentCallLeg }, childCall)));

    currentCallLeg = (<TelepoCdr[]>(<any>currentCallLeg).childCalls).lastItem;
  }


  return callLegs;
}
